import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import DropDown from "./DropDown";

//style rules
import { Typography, Colors, Sizes } from "../../styles";
import Context from "./Context";

const Filters = ({ title, text }) => {
	const {
		data: { filters, selectedFilters },
		actions: { handleFilterSelect, clearAllFilters },
	} = useContext(Context);

	const renderDropDowns = () => {
		if (filters.length === 0) return;

		return filters.map((dropDown) => {
			return (
				<DropDown
					key={dropDown.slug}
					filterKey={dropDown.slug}
					dropDownFilters={dropDown.filters}
					DropDownLabel={dropDown.title}
				/>
			);
		});
	};

	const renderSelectedFilters = () => {
		if (selectedFilters.length === 0) return;

		return (
			<SelectedFilters className="selectedFilters">
				<FlexRow>
					{selectedFilters.map((taxonomyObj) => {
						return taxonomyObj.filters.map((filter) => {
							return (
								<Selected
									dangerouslySetInnerHTML={{
										__html: filter.title + " x",
									}}
									onClick={() =>
										handleFilterSelect({
											taxonomy: taxonomyObj.taxonomy,
											filters: [filter],
										})
									}
									key={filter.slug}
								/>
							);
						});
					})}
				</FlexRow>
				<div>
					<ClearFiltersButton onClick={clearAllFilters}>
						Clear Filters
					</ClearFiltersButton>
				</div>
			</SelectedFilters>
		);
	};
	return (
		<Container>
			<Title>{title}</Title>
			<Text>{text}</Text>
			<FiltersContainer>{renderDropDowns()}</FiltersContainer>
			{renderSelectedFilters()}
		</Container>
	);
};

Filters.propTypes = {
	title: PropTypes.string,
	text: PropTypes.string,
	filters: PropTypes.array,
	handleFilterSelect: PropTypes.func,
	selectedFilters: PropTypes.array,
};

export default Filters;

const Container = styled.div`
	min-height: 262px;
	border-bottom: solid 2px ${Colors.base.black};
`;

const Title = styled.h2`
	font-size: 2rem;
	line-height: 2.6rem;
	letter-spacing: -0.0015em;
`;

const Text = styled.p`
	padding-top: 1.7rem;
	max-width: 700px;
`;

// the width of the drop down gets decided here
// we know that each dorpdown needs to have a width of 216px so we time that by number of dropdowns
const FiltersContainer = styled.div`
	padding-top: 2rem;
	display: flex;
	flex-direction: column;
	gap: 3rem;
	max-width: 432px;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		align-items: center;
		flex-direction: row;
	}
`;

const FlexRow = styled.div`
	display: flex;
	gap: 0.9rem;
`;

const SelectedFilters = styled.div`
	display: flex;
	gap: 0.9rem;
	justify-content: space-between;
	padding-top: 8rem;
	padding-bottom: 2.3rem;
`;

const Selected = styled.button`
	background: rgba(31, 31, 31, 0.9);
	border-radius: 0;
	padding: 0.3rem 0.7rem;
	height: fit-content;
	color: ${Colors.base.white};

	font-weight: ${Typography.fontWeight.black};
	font-size: 1.4rem;
	line-height: 2.2rem;
	letter-spacing: -0.001em;
	text-transform: uppercase;

	span {
		font-weight: ${Typography.fontWeight.regular};
	}
`;

const ClearFiltersButton = styled.button`
	background: none;
	padding: 0;
	height: fit-content;
	color: ${Colors.base.black};

	font-weight: ${Typography.fontWeight.regular};
	font-size: 1.4rem;
	line-height: 1.6rem;

	&:focus {
		box-shadow: none;
		border: solid 1px blue;
	}
`;
